export default __webpack_public_path__ + "static/media/youtube.ab3360a8.png";